import { render, staticRenderFns } from "./eval-detail-s2-4.vue?vue&type=template&id=65f5fd02&scoped=true"
import script from "./eval-detail-s2-4.vue?vue&type=script&lang=js"
export * from "./eval-detail-s2-4.vue?vue&type=script&lang=js"
import style0 from "./eval-detail-s2-4.vue?vue&type=style&index=0&id=65f5fd02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5fd02",
  null
  
)

export default component.exports